import { Component, signal, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { UtilService } from 'src/app/shared/helper/util.service';
import { SelectionGroup } from 'src/app/shared/request-access-dialog/request-access-dialog.component';
import { ManageRequestsService } from './manage-requests.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { AuthService } from '@auth0/auth0-angular';
import moment from 'moment';

@Component({
  selector: 'app-manage-requests',
  templateUrl: './manage-requests.component.html',
  styleUrl: './manage-requests.component.scss'
})
export class ManageRequestsComponent implements OnInit {
  searchTerm: string = '';
  isFilterOpen: boolean = false;
  openDropdownKey: string | null = null;
  selectedStatus = signal<string[]>(['All']);
  selectedCategory = signal<string[]>(['All']);
  
  // Tooltip state for copy-to-clipboard
  showTooltip: boolean = false;
  tooltipMessage: string = 'Copy email';
  tooltipEmail: string = '';
  tooltipTimeout: any;

  // Pagination properties
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  page: number = 1;
  // Popup properties
  isPopupOpen: boolean = false;
  selectedRequest: any | null = null;

  // New subscription form properties
  isCreatingNewSubscription: boolean = false;
  newSubscriptionForm: {
    remarks: string;
  } = {
    remarks: ''
   };

  // Available user group options for selection
  allUserGroupOptions:any = [];
  
  // Track which user groups are currently selected (for visual state)
  selectedUserGroups: string[] = [];

  filterForm: FormGroup = this.fb.group({
    status: ['All'],
    updatedOn: [''],
  });
  statusTypeId: any = 6;
  dataRequestForm: any;
  updatedOn = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
  statusFilterDropdownSettings: IDropdownSettings = {};
  categoryTypeFilterDropdownSettings: IDropdownSettings = {};
  userId: any = '';
  headerIds: any[] = [];
  statusIds: any[] = [];
  sortByValue: string = 'updated_date';
  sortTypeValue: string = 'desc';
  maxDate: Date = new Date();
  minDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  minExpiryDate: Date = new Date();
  activeSortIndex:any= null;
  isAscending: boolean = false;
  filterData: any[] =[];
  columns: string[] = ['Request ID', 'Category', 'Module', 'Submitted By', 'Organization', 'Updated On', 'Status', 'Actions'];
  errorFlag: boolean;
  isAdvancedFilter: boolean = false;
  clearPendingReqBanner: boolean =false;
  spinnerService: any;
  showErrorMessageWithPopup: any;
  errMsg: any='';
  error: any;
  showErrorToast: boolean;
  successMessage:any=''                
  accessSubscriptionList: any = [];
  subscriptionNameError: string;
  subscriptionEndDateError: string;
  subscriptionStartDateError: string;
  newSubscriptionFormGroup: FormGroup<any>;
   errorMessage = signal('');
  originalAvailableSubscriptions: any;
  userType: string = '';
  pendingItemsCount: any = 0;





  constructor(
    private fb: FormBuilder,private manageRequestsService: ManageRequestsService,
    private homePageService: HomePageService,
    private utilService: UtilService,
    private manageRequestService: ManageRequestsService,
    private auth: AuthService,
  ) {
    this.setMinMaxDates();
   }

  ngOnInit(): void {
    this.userType = localStorage.getItem('userType');
    this.buildForm();
    this.buildSubscriptionForm();
    this.settingForStatusDropdown();
    this.settingForCategoryDropdown()
    this.getAllStatuses();
    this.getAllHeaderCategory();
    this.getAccessRequestList();
    this.callSubjectSubscriptions();
  }

  callSubjectSubscriptions(){
    this.utilService.SharingDataPopUpMessage.subscribe((res: any) => {
          //  this.spinnerService.hide();
            this.errMsg = res;
          });
    this.utilService.getPopupStatus.subscribe((res: any) => {
            if (this.errMsg !== null) {
              this.showErrorMessageWithPopup = res;
            }
      });
  }
  onClearPendingRequests(){
    this.clearPendingReqBanner = true;
  }
  getAccessRequestList(){
   const filterValues = this.getFilterPayload();
   this.manageRequestsService.onAccessRequestDetailsFilter(filterValues,this.itemsPerPage,this.page).subscribe({
    next: (res: any) => {
      if (res?.code === 200) {
       this.filterData = res?.result ?? [];
       this.totalItems = res?.totalCount;
       this.pendingItemsCount = res?.pendingCount;
      }else {
        this.filterData = [];
        this.totalItems = 0;
      }
    },
    error: () => {
      this.filterData = [];
      this.totalItems = 0;
   }
  });
  }
    settingForStatusDropdown() {
      this.statusFilterDropdownSettings = {
        singleSelection: false,
        idField: 'statusId',
        textField: 'statusName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false,
      };
    }
  settingForCategoryDropdown() {
    this.categoryTypeFilterDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'headerName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
  }
buildForm() {
      this.dataRequestForm = this.fb.group({
        categoryType: new FormControl([]),
        updatedOn: this.updatedOn,
        statusType: new FormControl([]), 
      });
}
buildSubscriptionForm(){
   this.newSubscriptionFormGroup = this.fb.group({
        subscriptionId: [''],
        subscriptionName: ['', [Validators.required, this.subscriptionNameValidator.bind(this)]], 
        startDate: ['', [Validators.required]],
        endDate: ['', [Validators.required]],
      }, { validators: this.dateRangeValidator.bind(this) }) 
}
 setMinMaxDates() {
     const now = moment();
     this.minDate = now.startOf('month').toDate();
     this.maxDate = now.endOf('month').toDate();
   }

  // Custom validator to check if subscription name already exists
  subscriptionNameValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Let the required validator handle empty values
    }
    
    if (!this.availableSubscriptions || this.availableSubscriptions.length === 0) {
      return null; // No existing subscriptions to compare against
    }
    
    const subscriptionName = control.value.trim().toLowerCase();
    if (!subscriptionName) {
      return null; // Empty string after trim
    }
    
    const exists = this.availableSubscriptions.some((subscription: any) => 
      subscription.subscriptionName?.toLowerCase().trim() === subscriptionName
    );
    
    return exists ? { subscriptionExists: true } : null;
  }

  // Custom validator to check if end date is greater than start date
  dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    if (!group) {
      return null;
    }
    
    const startDate = group.get('startDate')?.value;
    const endDate = group.get('endDate')?.value;
    
    if (!startDate || !endDate) {
      return null; // Let individual field validators handle required validation
    }
    
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    if (end <= start) {
      return { dateRangeInvalid: true };
    }
    
    return null;
  }

  getAllStatuses() {
    this.manageRequestsService.getAllStatus(this.statusTypeId).subscribe((res: any) => {
      this.statusOptions = res.result;
    })
  }
   getAllHeaderCategory() {
      this.userId = localStorage.getItem('userId');
      this.homePageService.onHeader(this.userId).subscribe((res: any) => {
      let categoryList= res.result;
      categoryList = categoryList.filter((item: any) => item.homePageItem === true && item.headerName !== "Insights");
      this.categoryOptions = categoryList;
    })
  }
  // Get filtered requests based on search term, status, and category
  get filteredRequests() {
    let filtered = this.requestList;

    // Filter by status
    const selectedStatuses = this.selectedStatus();
    if (selectedStatuses.length > 0 && !selectedStatuses.includes('All')) {
      filtered = filtered.filter(request => 
        selectedStatuses.includes(request.status)
      );
    }

    // Filter by category
    const selectedCategories = this.selectedCategory();
    if (selectedCategories.length > 0 && !selectedCategories.includes('All')) {
      filtered = filtered.filter(request => 
        selectedCategories.includes(request.requestedCategory)
      );
    }

    // Filter by search term
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const searchLower = this.searchTerm.toLowerCase().trim();
      filtered = filtered.filter(request => 
        request.reqID.toLowerCase().includes(searchLower) ||
        request.requestedCategory.toLowerCase().includes(searchLower) ||
        request.requestedModule.toLowerCase().includes(searchLower) ||
        request.submittedByName.toLowerCase().includes(searchLower) ||
        request.submittedByEmail.toLowerCase().includes(searchLower) ||
        request.org.toLowerCase().includes(searchLower) ||
        request.status.toLowerCase().includes(searchLower)
      );
    }

    return filtered;
  }

  // Get total count of filtered items
  get filteredTotalItems(): number {
    return this.filteredRequests.length;
  }

  // Handle search input changes
  onSearchChange(): void {
    this.currentPage = 1; // Reset to first page when search changes
    this.onAdvancedFilter();
  }

  // Handle status selection changes
  onStatusSelectionChange(selectedStatuses: string[]): void {
    this.selectedStatus.set(selectedStatuses);
    this.currentPage = 1; // Reset to first page when filter changes
  }

  // Handle category selection changes
  onCategorySelectionChange(selectedCategories: string[]): void {
    this.selectedCategory.set(selectedCategories);
    this.currentPage = 1; // Reset to first page when filter changes
  }
  statusOptions:any = [];
  categoryOptions:any = [];
  
  requestList = [
    {
      id: '1',
      reqID: '124123123',
      requestedCategory: 'Data Product',
      requestedModule: 'Tire Pairing',
      submittedByName: 'Tyson Clay',
      submittedByEmail: 'tyson.clay@example.com',
      org: 'Michelin India Pvt Ltd',
      lastUpdated: '2024-05-01T10:20:30Z',
      status: 'Pending',
      requestedUserGroups: ['AGB-TC', 'ARB-TC']
      
    }
  ];

  availableSubscriptions:any = [];

  toggleFiltersCont() : void {
    this.isFilterOpen = !this.isFilterOpen;
  }

  resetAllFilters() {
    this.isAdvancedFilter = false;
    this.searchTerm = '';
    this.dataRequestForm.get('categoryType')?.setValue([]);
    this.dataRequestForm.get('statusType')?.setValue([]);

    this.updatedOn.reset();
    this.updatedOn.get('startDate')?.setValue(null);
    this.updatedOn.get('endDate')?.setValue(null);
    this.headerIds = [];
    this.statusIds = [];
    this.errorFlag = false;
    this.isAscending = false;
    this.activeSortIndex = null;
    this.sortByValue = '';
    this.sortTypeValue = '';
    this.page = 1;
    this.getAccessRequestList();
  }

  getRejectedRequestsCount() {
    return this.requestList.filter(request => request.status === 'REJECTED').length;
  }
  getPendingRequestsCount() {
    return this.filterData.filter(request => request.statusName === 'PENDING').length;
  }
  // Get total count of active filters
  getActiveFiltersCount(): number {
    let count = 0;
    if (this.selectedStatus().length > 0 && !this.selectedStatus().includes('All')) {
      count += this.selectedStatus().length;
    }
    if (this.selectedCategory().length > 0 && !this.selectedCategory().includes('All')) {
      count += this.selectedCategory().length;
    }
    return count;
  }

  getPaginatedStartIndex(): number {
    if (this.filteredTotalItems === 0) return 0;
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getPaginatedEndIndex(): number {
    const endIndex = this.currentPage * this.itemsPerPage;
    return endIndex > this.filteredTotalItems ? this.filteredTotalItems : endIndex;
  }

  onMultiSelectDropdownToggle(key: string) {
    this.openDropdownKey = this.openDropdownKey === key ? null : key;
  }

  // getPage(page: number): void {
  //   this.currentPage = page;
  // }

  getPageNumbers() {
    const totalPages = Math.ceil(this.filteredTotalItems / this.itemsPerPage);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // Copy email to clipboard functionality
  showCopyTooltip(email: string, event: MouseEvent): void {
    this.tooltipEmail = email;
    this.tooltipMessage = 'Copy email';
    this.showTooltip = true;
  }

  hideCopyTooltip(): void {
    this.showTooltip = false;
    this.tooltipEmail = '';
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
  }

  copyEmailToClipboard(email: string, event: MouseEvent): void {
    event.stopPropagation();
    navigator.clipboard.writeText(email).then(() => {
      this.tooltipMessage = 'Copied';
      this.showTooltip = true;
      
      // Hide tooltip after 2 seconds
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
      }
      this.tooltipTimeout = setTimeout(() => {
        this.showTooltip = false;
        this.tooltipEmail = '';
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy email:', err);
    });
  }

  metadata: { [key: string]: string } = {};
  selectionGroups: SelectionGroup[] = [];

  getMetadataKeys(): string[] {
    return Object.keys(this.metadata);
  }

  hasMetadata(): boolean {
    return Object.keys(this.metadata).length > 0;
  }

  // Open popup with selected request details
  openRequestDetailsPopup(request: any): void {
    this.isCreatingNewSubscription = false;
    this.resetNewSubscriptionForm();
    if(request.statusName === 'PENDING' ){
      this.getAccessRequestDetailsForPending(request.accessRequestId, request);
    }else {
       this.getAccessRequestDetails(request.accessRequestId,request);
    }
  }

    getAccessRequestDetails(accessRequestId:any, request:any){
      this.manageRequestService.getAccessRequestDetails(accessRequestId).subscribe((res: any) => {
            if(res.code==200){
              this.selectedRequest = res.result;
              this.selectedRequest.accessRequestId = accessRequestId;
              
              // Initialize all available user groups (keep all for display)
              //map isAssigned true to selected user groups by default
              this.allUserGroupOptions = this.selectedRequest?.userGroups ? 
                this.selectedRequest.userGroups.map((group: any) => ({
                  ...group,
                  isAssigned: true
                })) : [];
              
              // Initialize selected user groups (currently selected ones)
              this.selectedUserGroups = this.allUserGroupOptions ? [...this.allUserGroupOptions] : [];
              this.metadata = {
                'Requested by': this.selectedRequest.submittedByUserName,
                'Organization': this.selectedRequest.companyName,
                'Module': this.selectedRequest.moduleName,
              };
              if(request.statusName !== 'PENDING') this.isPopupOpen = true;
            }
      },error=>{
        this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.error = res
          })
          this.showErrorToast = true;
          setTimeout(() => { this.showErrorToast = false; this.error = ''; this.utilService.SharingDataTextMessage.next('') }, 5000)
      
      });
    }
    getAccessSubscriptionList(accessRequestId:any){
       this.manageRequestService.getAccessRequestSubscriptionsDetails(accessRequestId).subscribe((res: any) => {
            if(res.code==200){
              this.originalAvailableSubscriptions = res.result;
              this.availableSubscriptions = res.result;
              
              // Update validator when subscription list is loaded
              this.newSubscriptionFormGroup.get('subscriptionName')?.updateValueAndValidity();
              
              this.isPopupOpen = true;
            }
      },error=>{
        this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.error = res
          })
          this.showErrorToast = true;
          setTimeout(() => { this.showErrorToast = false; this.error = ''; this.utilService.SharingDataTextMessage.next('') }, 5000)
      
      });
    }
    getAccessRequestDetailsForPending(accessRequestId:any, request:any){
      this.getAccessRequestDetails(accessRequestId,request);
      this.getAccessSubscriptionList(accessRequestId);
    }
  // Close popup
  closePopup(): void {
    this.isPopupOpen = false;
    this.selectedRequest = null;
    this.selectedUserGroups = []; // Clear selected user groups
    this.allUserGroupOptions = []; // Clear all user group options
    this.metadata = {};
  }
  acceptOrRejectRequest(accessRequestId:any,action:any) {
    //here addd validation msg if request action is approved then subscription name , start date , end date should be mandatory and remarks also mandatory for rejected action but in case of rejected remarks is mandetory not subscription details
    
    this.accessRequestAction(accessRequestId, action);
 }


  rejectRequestPayload(accessRequestId:any,action:any) {
  let payload = {
      userId: localStorage.getItem('userId'),
      accessRequestId: accessRequestId,
      submittedByUserId: this.selectedRequest.submittedByUserId,
      companyId: this.selectedRequest.companyId,
      companyName: this.selectedRequest.companyName,
      isExistingSubscription: this.selectedRequest.isExistingSubscription,
      remarks: this.newSubscriptionForm.remarks,
      subscriptionDetails: {
        moduleDto: {
          id: this.selectedRequest.moduleId,
          moduleName: this.selectedRequest.moduleName,
          isModuleAttached: true,
          userAccessRole: "USER",
          userGroups: this.getMappedUserGroups(this.allUserGroupOptions)
        },
        neverEndSubscription: false,
        productPlan: "Free",
        price: 0
      },
      action: action,
      isAdmin: false,
    

  }
  console.log(payload);
  return payload;
  }
acceptRequestPayload(accessRequestId:any, action:any) {
    let payload = {
      userId: localStorage.getItem('userId'),
      accessRequestId: accessRequestId,
      submittedByUserId: this.selectedRequest.submittedByUserId,
      companyId: this.selectedRequest.companyId,
      companyName: this.selectedRequest.companyName,
      isExistingSubscription: this.newSubscriptionFormGroup.get('subscriptionId')?.value? true : false,
      remarks: this.newSubscriptionForm.remarks,
      subscriptionDetails: {
        subscriptionId: this.newSubscriptionFormGroup.get('subscriptionId')?.value,
        subscriptionName: this.newSubscriptionFormGroup.get('subscriptionName')?.value,
        startDate: formatDate(this.newSubscriptionFormGroup.get('startDate')?.value, 'yyyy-MM-dd', 'en-US'),
        endDate: formatDate(this.newSubscriptionFormGroup.get('endDate')?.value, 'yyyy-MM-dd', 'en-US'),
        neverEndSubscription: true,
        moduleDto: {
          id: this.selectedRequest.moduleId,
          moduleName: this.selectedRequest.moduleName,
          isModuleAttached: true,
          userAccessRole: "USER",
          userGroups: this.getMappedUserGroups(this.allUserGroupOptions)
        },
        productPlan: "Free",
        price: 0
      },
      action: action,
      isAdmin: false,
    }
    console.log(payload);
    return payload;
  }
  getMappedUserGroups(userGroups: any[]): any[] {
   return userGroups.map(group => ({
      id: group.id,
      isAssigned: group.isAssigned,
      userGroupDescription: group.userGroupDescription,
      userGroupName: group.userGroupName
    }));

  }
  refreshAccessRequestList(){
    this.page = 1;
    this.getAccessRequestList();
  }
  validatePayload(action: any, payload: any) {
  if (action === 'Approved') {
        // Check required fields for approval
      if (!payload.subscriptionDetails?.subscriptionName || 
            !payload.subscriptionDetails?.startDate || 
            !payload.subscriptionDetails?.endDate) {
          this.error = 'Subscription details are required for approval action';
          this.showErrorToast = true;
          setTimeout(() => { this.showErrorToast = false; this.error = ''; }, 5000);
          return;
        }
        if (!payload.remarks) {
          this.error = 'Remarks are required for approval action';
          this.showErrorToast = true;
          setTimeout(() => { this.showErrorToast = false; this.error = ''; }, 5000);
          return;
        }
       } else if (action === 'Rejected') {
        // Check required fields for rejection
        if (!payload.remarks) {
          this.error = 'Remarks are required for rejection action';
          this.showErrorToast = true;
          setTimeout(() => { this.showErrorToast = false; this.error = ''; }, 5000);
          return;
        }
      }
  }
  accessRequestAction(accessRequestId:any, action:any){
    let payload:any;
    if(action=='Approved'){
      payload = this.acceptRequestPayload(accessRequestId, action);
    }else if(action=='Rejected'){
      payload = this.rejectRequestPayload(accessRequestId, action);
    }
    if (action === 'Approved') {
      // Check required fields for approval
     if (!payload.subscriptionDetails?.subscriptionName || 
          !payload.subscriptionDetails?.startDate || 
          !payload.subscriptionDetails?.endDate) {
        this.error = 'Subscription details are required for approval action';
        this.showErrorToast = true;
        setTimeout(() => { this.showErrorToast = false; this.error = ''; }, 5000);
        return;
      }
      if (!payload.remarks) {
        this.error = 'Remarks are required for approval action';
        this.showErrorToast = true;
        setTimeout(() => { this.showErrorToast = false; this.error = ''; }, 5000);
        return;
      }
      } else if (action === 'Rejected') {
      // Check required fields for rejection
      if (!payload.remarks) {
        this.error = 'Remarks are required for rejection action';
        this.showErrorToast = true;
        setTimeout(() => { this.showErrorToast = false; this.error = ''; }, 5000);
        return;
      }
    }
    this.manageRequestService.accessRequestAction(payload).subscribe((res: any) => {
          if(res.code==200){
            this.successMessage = res.result;
            this.showErrorToast = true;
            this.refreshAccessRequestList();
            this.cancelNewSubscription();
            this.isPopupOpen = false;
            setTimeout(() => { this.showErrorToast = false; this.successMessage = '';  }, 5000)
          }
    },error=>{
      this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.error = res
          })
      this.showErrorToast = true;
      setTimeout(() => { this.showErrorToast = false; this.error = ''; this.utilService.SharingDataTextMessage.next('') }, 5000)
      
    });
  }

  
  // Handle subscription selection from radio button
  onSubscriptionSelect(subscription: any): void {
  //  this.selectedRequest.subscriptionId = subscription.subscriptionId || '';
    this.newSubscriptionFormGroup.get('subscriptionId')?.setValue(subscription.subscriptionId||'');
    this.newSubscriptionFormGroup.get('subscriptionName')?.setValue(subscription.subscriptionName);
    this.newSubscriptionFormGroup.get('startDate')?.setValue(new Date(subscription.startDate));
    this.newSubscriptionFormGroup.get('endDate')?.setValue(new Date(subscription.endDate));
  }

  // Check if a user group is currently selected for the request
  isUserGroupSelected(userGroup: any): boolean {
    return userGroup.isAssigned === true;
  }
  selectedUserGroupCount(): number {
    return this.allUserGroupOptions.filter((group:any) => group.isAssigned).length;
  }

  // Toggle user group selection for the current request
  toggleUserGroup(userGroup: any): void {
    if (!this.selectedRequest) {
      return;
    }

    const userGroupIndex = this.allUserGroupOptions.findIndex((group: any) => 
      group.id === userGroup.id
    );
    
    if (userGroupIndex > -1) {
      this.allUserGroupOptions[userGroupIndex].isAssigned = !this.allUserGroupOptions[userGroupIndex].isAssigned;
    }
    this.selectedUserGroups = this.allUserGroupOptions;
    this.selectedRequest.userGroups = [...this.selectedUserGroups];
  }

  // Create new subscription and add to available subscriptions
  createNewSubscription(): void {
    // Reset form with default values
    this.newSubscriptionFormGroup.reset();
    this.isCreatingNewSubscription = true;
  }

  // Save the new subscription from the form
   saveNewSubscription(): void {
        // Custom validation logic instead of relying on form.invalid
        const subscriptionName = this.newSubscriptionFormGroup.get('subscriptionName')?.value?.trim();
        const startDate = this.newSubscriptionFormGroup.get('startDate')?.value;
        const endDate = this.newSubscriptionFormGroup.get('endDate')?.value;
        
        // Check required fields manually
        if (!subscriptionName) {
          this.newSubscriptionFormGroup.get('subscriptionName')?.markAsTouched();
          return;
        }
        
        if (!startDate) {
          this.newSubscriptionFormGroup.get('startDate')?.markAsTouched();
          return;
        }
        
        if (!endDate) {
          this.newSubscriptionFormGroup.get('endDate')?.markAsTouched();
          return;
        }
        
        // Check if subscription name already exists
        const subscriptionExists = this.availableSubscriptions.some((subscription: any) => 
          subscription.subscriptionName?.toLowerCase().trim() === subscriptionName.toLowerCase()
        );
        
        if (subscriptionExists) {
          this.newSubscriptionFormGroup.get('subscriptionName')?.markAsTouched();
          return;
        }
        
        // Check date range (end date should be after start date)
        const start = new Date(startDate);
        const end = new Date(endDate);
        
        if (end <= start) {
          this.newSubscriptionFormGroup.get('endDate')?.markAsTouched();
          return;
        }
         // All validations passed, proceed with creating subscription
     

    const newSubscription = {
      subscriptionId: '',
      subscriptionName: this.newSubscriptionFormGroup.get('subscriptionName')?.value.trim(),
      startDate: new Date(this.newSubscriptionFormGroup.get('startDate')?.value),
      endDate: new Date(this.newSubscriptionFormGroup.get('endDate')?.value)
    };
    
    this.availableSubscriptions.unshift(newSubscription);
    
    // Update validator to check against updated list
    this.newSubscriptionFormGroup.get('subscriptionName')?.updateValueAndValidity();
    
    // Automatically select the newly created subscription for the current request
    this.onSubscriptionSelect(newSubscription);
  
    // Hide the form
    this.isCreatingNewSubscription = false;
   // this.resetNewSubscriptionForm();
   }
  endDate(event: any) {
    if (event.target.value !== null) {
      let formattedDate = moment().format('YYYY-MM-DD');
      if (moment(event.target.value).isBefore(formattedDate)) {
        this.newSubscriptionFormGroup.get('endDate')?.markAsTouched();
        return;
      } 
    } 
  }
  // Cancel new subscription creation
  cancelNewSubscription(): void {
    this.isCreatingNewSubscription = false;
  //  this.newSubscriptionFormGroup.reset();
    let selectedSubscription = this.availableSubscriptions[0];
    this.onSubscriptionSelect(selectedSubscription);
  }

  // Reset the new subscription form
  private resetNewSubscriptionForm(): void {
    this.newSubscriptionForm = {
        remarks: ''
    };
    this.newSubscriptionFormGroup.reset();
  }
 

  onStatusSelect(item: any) {
      const control = this.dataRequestForm.get('statusType') as FormControl;
      const current = control.value || [];
      if (!current.find((i: any) => i.statusId === item.statusId)) {
        control.setValue([...current, item]);
      }
      this.statusIds = control.value.map((i: any) => i.statusId);
      this.onAdvancedFilter();
  }
   
   onStatusDeselect(item: any) {
    const selected = this.dataRequestForm.get('statusType')?.value || [];
    this.statusIds = selected.map((x: any) => x.statusId);
    this.onAdvancedFilter();
  }
onSelectAllStatusTypes(items: any) {
  this.dataRequestForm.get('statusType')?.setValue(items);
  this.statusIds = items.map((x: any) => x.statusId);
  this.onAdvancedFilter();
}

onDeSelectAllStatusTypes(items: any) {
  const control = this.dataRequestForm.get('statusType') as FormControl;
  control.setValue([]); // Clear all
  this.statusIds = [];
  this.onAdvancedFilter();
}

onCategorySelect(item: any) {
  const selected = this.dataRequestForm.get('categoryType')?.value || [];
  this.headerIds = selected.map((x: any) => x.id);  // or just use selected if it's IDs
  this.onAdvancedFilter();
}
onCategoryDeselect(item: any) {
  const selected = this.dataRequestForm.get('categoryType')?.value || [];
  this.headerIds = selected.map((x: any) => x.id);
  this.onAdvancedFilter();
}

onSelectAllCategoryTypes(items: any) {
    this.dataRequestForm.get('categoryType')?.setValue(items);
      this.headerIds = items.map((x: any) => x.id);
      this.onAdvancedFilter();
}
onDeSelectAllCategoryTypes(items: any) {
  this.dataRequestForm.get('categoryType')?.setValue([]);
  this.headerIds = [];
  this.onAdvancedFilter();
}

onSort(column: string,i:any) {
    if (column === 'Updated On') {
      this.sortByValue = 'updated_date';
    }
    this.activeSortIndex = i;
    this.isAscending = !this.isAscending;
    this.sortTypeValue = this.isAscending ? 'asc' : 'desc';
    this.onAdvancedFilter();
  }
onAdvancedFilter(){
  this.isAdvancedFilter = true;
  this.page = 1;
  this.getAccessRequestList();
}
getFilterPayload(){
  let filterPayload = {
  userId:localStorage.getItem('userId'),
  searchText: this.searchTerm,
  headerId: this.headerIds,
  statusId: this.statusIds,
  updatedDate: {
          startDate: this.updatedOn.get('startDate')?.value ? formatDate(this.updatedOn.get('startDate')?.value, 'yyyy-MM-dd', 'en-US') : null,
          endDate: this.updatedOn.get('endDate')?.value ? formatDate(this.updatedOn.get('endDate')?.value, 'yyyy-MM-dd', 'en-US') : null
        },
  sortBy: this.sortByValue,
  sortType: this.sortTypeValue,
}
return filterPayload;
}
onDateSelected() {
  this.onAdvancedFilter();
}

getSelectedFilterCount(): number {
    let count = 0;

    // Request Type filter
    const typeArray = this.dataRequestForm.get('categoryType').value;
    if (typeArray && typeArray.length > 0) {
      count++;
    }

    

    // Modified Date filter
    const updatedStart = this.updatedOn.get('startDate')?.value;
    const updatedEnd = this.updatedOn.get('endDate')?.value;
    if (updatedStart || updatedEnd) {
      count++;
    }

    // Status filter
    const statusArray = this.dataRequestForm.get('statusType')?.value;
    if (statusArray && statusArray.length > 0) {
      count++;
    }

    // Search filter
    const searchText = this.searchTerm;
    if (searchText && searchText.trim().length > 0) {
      count++;
    }

    return count;
  }

getPage(event: any) {
  this.page = event;
  this.currentPage = this.page - 1;
  this.getAccessRequestList();
}

  onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace('/login');
    }else{
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }
}

